export default __webpack_public_path__ + "static/oi-live-comp-0f9a572a0770b63013243cb293f0f5cd.png";